var _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileApps1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8921 9.90379C2.90702 11.0728 -0.505781 35.3877 3.10719 48.516C3.63545 53.9423 14.729 61.5844 22.7958 57.5161C37.0667 50.3188 39.7999 54.5676 54.8259 57.6367C62.4918 59.2025 64.7416 39.5812 64.2365 37.6005C63.7314 35.6199 59.1236 8.44253 27.8921 9.90379Z",
    fill: "#F3FBFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4987_3160",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4987_3160)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.3931,
    y: 19.9639,
    width: 13.9286,
    height: 26.0714,
    rx: 1.75,
    stroke: "#EED919",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1431,
    y: 21.5713,
    width: 5.71429,
    height: 1.42857,
    rx: 0.714286,
    fill: "#EED919"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.4287,
    y: 41.5713,
    width: 7.14286,
    height: 1.42857,
    rx: 0.714286,
    fill: "#EED919"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileApps1);
export default __webpack_public_path__ + "static/media/mobile-apps-1.7174ab3a1c12eb524eb1acdb083009f3.svg";
export { ForwardRef as ReactComponent };